import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useInView } from 'react-intersection-observer';

const Mission: React.FC = () => {
  const { t } = useTranslation('about');
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section className="py-20 section-dark" ref={ref}>
      <div className="container-custom">
        <motion.div
          className="max-w-4xl mx-auto text-center"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-8 gradient-text">
            {t('mission.title')}
          </h2>
          <p className="text-xl text-secondary leading-relaxed">
            {t('mission.body')}
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Mission;
